import { MenuItem, MenuList } from "@mui/material";
import React, { useRef } from "react";
import { translate } from "../../../../../providers";
import { CustomMenuButton } from "../../../../buttons";
import { icon, IconComponent } from "../../../../icon-component";
import styles from "./FiltersSelector.module.css";

export default function FiltersSelector({
	addFilterButtonVariant = "outlined",
	filters,
	onClickKey,
	disabled = false,
	readOnly,
	forceOpenSelector = false,
	selectorButtonSize = "md",
	selectorIconSize = "sm",
}) {
	const menuButtonRef = useRef(null);
	const handleChange = (key) => {
		if (menuButtonRef.current) {
			menuButtonRef.current.onClose();
		}
		onClickKey(key);
	};
	const hasIcon = filters.some((filter) => !!filter.icon);
	if (readOnly) {
		return null;
	}
	return (
		<CustomMenuButton
			ref={menuButtonRef}
			color={addFilterButtonVariant === "contained" ? "primary" : "secondary"}
			disabled={disabled}
			forceOpenSelector={forceOpenSelector}
			size={selectorButtonSize}
			text={
				<>
					<IconComponent
						color={addFilterButtonVariant === "contained" ? "var(--color-white)" : "var(--grey-500)"}
						icon={icon.faPlus}
						size={selectorIconSize}
					/>
					{translate("common:filters.select-filter.title")}
				</>
			}
			variant={addFilterButtonVariant}
		>
			<MenuList className={styles.menuList}>
				{filters.map((filter) => (
					<MenuItem key={filter.key} className={styles.menuItem} onClick={() => handleChange(filter.key)}>
						<div className={hasIcon ? styles.menuItem__icon : ""}>
							{filter.icon && <IconComponent color="var(--grey-500)" icon={filter.icon} size="xs" />}
						</div>
						<div className={styles.menuItem__text}>{translate(filter.label)}</div>
					</MenuItem>
				))}
			</MenuList>
		</CustomMenuButton>
	);
}
